module.exports = __webpack_public_path__ + "static/img/057_TO8_1605_og.7976187.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/057_TO8_1605_og.jpg
// module id = JS1B
// module chunks = 0